<template>
  <div id="app-layout-fullpage" class="app-layout app-layout-fullpage">
    <div class="app-layout-fullpage-wrpper">
      <div class="container">
        <div class="app-layout-fullpage-container">
          <div class="app-layout-fullpage-content" :style="dashboardWrapperStyles">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutFullpage',

  data() {
    return {
      viewHeight: 0,
    };
  },

  computed: {
    dashboardWrapperStyles() {
      return {
        minHeight: `${this.viewHeight}px`,
      };
    },
  },

  methods: {
    onWindowResize() {
      this.viewHeight =
        window.innerWidth >= 768
          ? window.innerHeight - 71 - 96
          : window.innerHeight - window.innerWidth * 0.6 - 48;
    },
  },

  mounted() {
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },
};
</script>
